import React, { useState } from 'react';
import {
  Table, Tag, Card, Alert, Typography, Space, Input, Select, Button, Form
} from 'antd';
import { SearchOutlined, ReloadOutlined, InfoCircleOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const mockData = [
  {
    key: '1',
    productName: '工业网关 G100',
    productId: 'PRD_GW001',
    sourceEnterprise: '蓝海工业自动化',
    sourceEnterpriseId: 'ENT_8802',
    transferTime: '2026-05-05 14:30:00',
    deviceCount: 10,
    status: 'active',
  },
  {
    key: '2',
    productName: '温湿度传感器',
    productId: 'PRD_THS002',
    sourceEnterprise: '森态环境监测中心',
    sourceEnterpriseId: 'ENT_8803',
    transferTime: '2026-05-03 16:10:00',
    deviceCount: 5,
    status: 'active',
  },
  {
    key: '3',
    productName: '4G摄像机',
    productId: 'PRD_4G001',
    sourceEnterprise: '深圳汇云科技',
    sourceEnterpriseId: 'HM_8827_X',
    transferTime: '2026-05-09 09:00:00',
    deviceCount: 12,
    status: 'active',
  },
  {
    key: '4',
    productName: '智能门锁 S1',
    productId: 'PRD_SL001',
    sourceEnterprise: '捷顺科技股份有限公司',
    sourceEnterpriseId: 'A619355x',
    transferTime: '2026-04-20 11:00:00',
    deviceCount: 30,
    status: 'inactive',
  },
];

const ReferencedProductList = () => {
  const navigate = useNavigate();
  const [dataSource] = useState(mockData);
  const [filters, setFilters] = useState({ productName: '', sourceEnterprise: '', status: '' });

  const filteredData = dataSource.filter(item => {
    if (filters.productName && !item.productName.includes(filters.productName)) return false;
    if (filters.sourceEnterprise && !item.sourceEnterprise.includes(filters.sourceEnterprise)) return false;
    if (filters.status && item.status !== filters.status) return false;
    return true;
  });

  const columns = [
    {
      title: '产品信息',
      key: 'product',
      width: 240,
      render: (_, r) => (
        <div>
          <div style={{ fontWeight: 500 }}>{r.productName}</div>
          <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.productId}</Text>
        </div>
      ),
    },
    {
      title: '来源企业',
      key: 'source',
      width: 200,
      render: (_, r) => (
        <div>
          <div style={{ fontWeight: 500 }}>{r.sourceEnterprise}</div>
          <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.sourceEnterpriseId}</Text>
        </div>
      ),
    },
    { title: '引入设备数', dataIndex: 'deviceCount', key: 'deviceCount', width: 100 },
    { title: '引入时间', dataIndex: 'transferTime', key: 'transferTime', width: 170 },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (s) => {
        if (s === 'active') return <Tag color="blue" style={{ border: 'none' }}>正常</Tag>;
        return <Tag color="default" style={{ border: 'none' }}>已失效</Tag>;
      },
    },
    {
      title: '操作',
      key: 'action',
      width: 220,
      render: (_, r) => (
        <Space size={0} split={<span style={{ color: '#d9d9d9', margin: '0 6px' }}>|</span>}>
          <Button
            type="link"
            size="small"
            icon={<EyeOutlined />}
            onClick={() => navigate(`/product/develop?productId=${r.productId}&productName=${encodeURIComponent(r.productName)}&readonly=true`)}
          >
            查看物模型
            <Tag color="orange" style={{ marginLeft: 4, border: 'none', fontSize: 10, lineHeight: '16px' }}>只读</Tag>
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>引入的产品</Title>
      </div>

      <Alert
        message="什么是引入的产品？"
        description="这些产品来自其他合作企业的设备调拨。仅可查看关联产品的物模型配置（只读），不可发起固件 OTA 升级。产品的归属权和编辑权仍属于原始企业。"
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        closable
        style={{ marginBottom: 16, borderRadius: 8 }}
      />

      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form layout="inline">
          <Form.Item style={{ marginBottom: 0 }}>
            <Input
              placeholder="产品名称搜索"
              style={{ width: 200 }}
              value={filters.productName}
              onChange={(e) => setFilters(prev => ({ ...prev, productName: e.target.value }))}
              allowClear
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Input
              placeholder="来源企业搜索"
              style={{ width: 200 }}
              value={filters.sourceEnterprise}
              onChange={(e) => setFilters(prev => ({ ...prev, sourceEnterprise: e.target.value }))}
              allowClear
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Select
              placeholder="状态"
              style={{ width: 120 }}
              value={filters.status || undefined}
              onChange={(val) => setFilters(prev => ({ ...prev, status: val || '' }))}
              allowClear
            >
              <Select.Option value="active">正常</Select.Option>
              <Select.Option value="inactive">已失效</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" icon={<SearchOutlined />}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={() => setFilters({ productName: '', sourceEnterprise: '', status: '' })}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card bordered={false}>
        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="key"
          scroll={{ x: 1050 }}
          pagination={{
            showSizeChanger: true,
            showTotal: (t) => `共 ${t} 个引用产品`,
            defaultPageSize: 10,
          }}
          locale={{ emptyText: '暂无引入的产品' }}
        />
      </Card>
    </div>
  );
};

export default ReferencedProductList;
